import { ENVIRONMENT_NAME } from '../config';

let AllLandingPages = [];

// Add environment-specific landing pages only
if (ENVIRONMENT_NAME === 'cn') {
    AllLandingPages = [
        {
            name: "Microsoft Login",
            landingPagePath: 'https://uk.sat.clouduss.com/assets/img/landingpage/Second+stage+placeholder+Microsoft//tmp/TempStorage/Second+stage+placeholder+Microsoft/Second+stage+placeholder+Microsoft/index.html',
        },
        {
            name: "Google Login",
            landingPagePath: 'https://uk.sat.clouduss.com/assets/img/landingpage/Second+stage+placeholder+Google//tmp/TempStorage/Second+stage+placeholder+Google/Second+stage+placeholder+Google/index.html',
        }
    ];
} else if (ENVIRONMENT_NAME === 'cnde') {
    AllLandingPages = [
        {
            name: "Microsoft Login",
            landingPagePath: 'https://de.sat.clouduss.com/assets/img/landingpage/Second+stage+placeholder+Microsoft//tmp/TempStorage/Second+stage+placeholder+Microsoft/Second+stage+placeholder+Microsoft/index.html',
        },
        {
            name: "Google Login",
            landingPagePath: 'https://de.sat.clouduss.com/assets/img/landingpage/Second+stage+placeholder+Google//tmp/TempStorage/Second+stage+placeholder+Google/Second+stage+placeholder+Google/index.html',
        }
    ];
} else {
    // Default landing pages for other environments
    AllLandingPages = [
        {
            name: "Microsoft Login",
            landingPagePath: 'https://d35p3si8xgkjxu.cloudfront.net/assets/img/landingpage/Two%20Stage%20Landing%20Page//tmp/TempStorage/Two%20Stage%20Landing%20Page/Two%20Stage%20Landing%20Page/index.html',
        },
        {
            name: "Google Login",
            landingPagePath: "/landing-page/default",
        }
    ];
}

export default AllLandingPages;